import { createEvent, sample, combine } from 'effector';
import { createForm } from 'effector-forms';
import rules from 'src/effector/forms/rules';
import { getErrors } from 'src/effector/forms/helpers';
import * as api from 'src/logic/api';

const next = createEvent();
const submit = createEvent();

const form = createForm({
  fields: {
    profession: {
      init: '',
      rules: [rules.required()],
    },
    ssn_itin: {
      init: '',
      rules: [
        rules.required(),
        {
          name: 'ssn-format',
          validator: value =>
            /^[A-Za-z0-9]{3}-[A-Za-z0-9]{2}-[A-Za-z0-9]{4}$/.test(value),
          errorText: 'Invalid SSN/ITIN format (XXX-XX-XXXX)',
        },
      ],
    },
    ein: {
      init: '',
      rules: [
        rules.required(),
        {
          name: 'ein-format',
          validator: value => /^[0-9]{2}-[0-9]{7}$/.test(value),
          errorText: 'Invalid EIN format (XX-XXXXXXX)',
        },
      ],
    },
  },
});

sample({
  clock: sample({
    clock: submit,
    target: form.validate,
  }),
  source: form.$isValid,
  filter: isValid => isValid,
  target: next,
});

const $formErrors = getErrors(Object.keys(form.fields), form);
const $isValidForm = form.$isValid.map(isValid => isValid);

export const stores = {
  form,
  $formErrors,
  $isValidForm,
};

export const store = combine(stores);

export const actions = {
  submit,
  next,
};
